import { IDialogProps } from 'office-ui-fabric-react'
import { useCallback, useState } from 'react'

export type DialogState = Pick<IDialogProps, 'hidden' | 'onDismiss'>

export function useDialogState(initialState: DialogState = { hidden: true }) {
  const [dialogState, setDialogState] = useState<DialogState>(initialState)

  const hideDialog = useCallback(
    () => setDialogState({ hidden: true }),
    [setDialogState]
  )
  const showDialog = useCallback(
    () => setDialogState({ hidden: false }),
    [setDialogState]
  )

  return [
    { ...dialogState, onDismiss: hideDialog },
    showDialog,
    hideDialog,
  ] as [DialogState, typeof showDialog, typeof hideDialog]
}
